import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// CRÍTICO: Forzar v2 ANTES de que se cargue cualquier otro código
// Esto previene que cualquier código establezca v1 durante la inicialización
if (typeof window !== 'undefined') {
    console.log('[index.tsx] 🚀 Inicializando - Forzando v2...');
    console.log('[index.tsx]   - Timestamp:', new Date().toISOString());
    console.log('[index.tsx]   - URL:', window.location.href);
    console.log('[index.tsx]   - Width:', window.innerWidth);
    
    const VERSION_STORAGE_KEY = 'infrasol_web_version';
    const stored = localStorage.getItem(VERSION_STORAGE_KEY);
    console.log('[index.tsx]   - localStorage antes:', stored);
    
    if (stored === 'v1') {
        console.error('[index.tsx] ⚠️⚠️⚠️ v1 detectado en index.tsx, eliminando...');
        localStorage.removeItem(VERSION_STORAGE_KEY);
    }
    
    // SIEMPRE forzar v2 al inicio
    if (!stored || stored === 'v1') {
        localStorage.setItem(VERSION_STORAGE_KEY, 'v2');
        console.log('[index.tsx] ✅ v2 forzado en localStorage');
    }
    
    const afterStored = localStorage.getItem(VERSION_STORAGE_KEY);
    console.log('[index.tsx]   - localStorage después:', afterStored);
    
    // INTERCEPTOR: Monitorear cambios en localStorage
    const originalSetItem = Storage.prototype.setItem;
    Storage.prototype.setItem = function(key, value) {
        if (key === VERSION_STORAGE_KEY && value === 'v1') {
            const urlParams = new URLSearchParams(window.location.search);
            const versionParam = urlParams.get('version');
            if (versionParam !== 'v1') {
                console.error('[index.tsx] 🚫 INTERCEPTADO: Intento de establecer v1 en localStorage');
                console.error('[index.tsx]   - Stack trace:');
                console.trace();
                console.error('[index.tsx]   - URL:', window.location.href);
                console.error('[index.tsx]   - Width:', window.innerWidth);
                console.error('[index.tsx]   - Query parameter version:', versionParam);
                console.error('[index.tsx]   - BLOQUEADO y forzando v2');
                value = 'v2';
            }
        }
        return originalSetItem.call(this, key, value);
    };
    
    console.log('[index.tsx] ✅ Interceptor de localStorage instalado');
}

const element = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(element);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);